module.exports = __webpack_public_path__ + "static/img/human-2.8877a0aa.png";